module.exports = Object.assign({}, require('./online'), {
  ENGLISH_DOUBLE_WEEK_TRIAL_LESSON: '124',

  // ---- OSS 配置 -----
  OSS_BUCKET: 'static-nginx-online',
  OSS_MID_PATH: 'h5/zebra-ai-page-test'
  // ---- OSS 配置 -----
})
